// extracted by mini-css-extract-plugin
export default {"page":"LegalPage_page__kn3jy","inner":"LegalPage_inner__WicMX","eyebrow":"LegalPage_eyebrow__sMrE+","updated":"LegalPage_updated__tcTSf"};